"use strict";
import "src/decidim/map/provider/default";
import "src/decidim/map";
